"use strict";

let BulmaDropdown = {
    options: {
        selector: ".dropdown:not(.is-hoverable)",
    },
};

BulmaDropdown.init = function (userOptions) {
    for (const prop in userOptions) {
        if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
            this.options[prop] = userOptions[prop];
        }
    }


    const self = this;
    document.addEventListener('keydown', (event) => {
        if(event.key === "Escape") {
            self.closeAll();
        }
    });

    document.addEventListener("click", () => {
        self.closeAll();
    });

    this.initSelectors(document);
}

BulmaDropdown.initSelectors = function (rootElement) {
    const dropdown_elements = Array.prototype.slice.call(rootElement.querySelectorAll(this.options.selector), 0);

    dropdown_elements.forEach( dropdown_element => {
        if (dropdown_element.hasOwnProperty('moduleBulmaDropdownInitialized')) { return; }
        dropdown_element.moduleBulmaDropdownInitialized = true;

        if (!dropdown_element.querySelector("button,a")) {
            return;
        }

        dropdown_element.querySelector("button,a").addEventListener("click", (event) => {
            dropdown_element.classList.toggle("is-active");
            event.stopPropagation();
            event.preventDefault();
        });
    });
}

BulmaDropdown.close = function (element) {
    element.classList.remove('is-active');
}

BulmaDropdown.closeAll = function() {
    const self = this;
    (document.querySelectorAll(self.options.selector) || []).forEach((dropdown_element) => {
        self.close(dropdown_element);
    });
}

export { BulmaDropdown };